export const REALTIME_STATUS_RETRY_MS = 5_000;

export function startRealtimeStatusPolling({ check, delay = REALTIME_STATUS_RETRY_MS, schedule = setTimeout, cancel = clearTimeout }) {
  let stopped = false;
  let timer = null;

  async function poll() {
    const available = await check();
    if (stopped || available) return;
    timer = schedule(() => {
      timer = null;
      void poll();
    }, delay);
  }

  void poll();
  return () => {
    stopped = true;
    if (timer !== null) cancel(timer);
  };
}
